import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrphanedDeviceList } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class OrphanedDevicesResource {
  private http = inject(HttpClient);

  find(): Observable<OrphanedDeviceList> {
    return this.http.get<OrphanedDeviceList>(`/services/cisco/reporting/orphaned-devices/`);
  }
}
